import { useMutation } from '@apollo/client'
import { EditEventDay, EditEventDayVariables } from '../../types'
import { EDIT_EVENT_DAYS } from './operations'

export const useEditEventDay = () =>
  useMutation<EditEventDay, EditEventDayVariables>(EDIT_EVENT_DAYS)